import { IUserState } from 'src/interface';

export enum ACTIONS {
    SET_ASSETS = 'USER_SET_ASSETS',
    FOLLOW = 'USER_FOLLOW',
    LIKE = 'USER_LIKE',
    BOOKMARK = 'USER_BOOKMARK',
    FOLLOW_SOCCEERS = 'USER_FOLLOW_SOCCERS',
    FOLLOW_SOCCEER = 'USER_FOLLOW_SOCCER',
    UNFOLLOW_SOCCEER = 'USER_UNFOLLOW_SOCCERS',
}

export const updateUserAssets = (userAssets: IUserState) => ({
    type: ACTIONS.SET_ASSETS,
    payload: userAssets,
});

export const follow = (objectType: string, objectId: number) => ({
    type: ACTIONS.FOLLOW,
    payload: {
        objectType,
        objectId,
    },
});

export const like = (id: number) => ({
    type: ACTIONS.LIKE,
    payload: {
        id,
    },
});

export const bookmark = (id: number) => ({
    type: ACTIONS.BOOKMARK,
    payload: {
        id,
    },
});

export const followSoccers = (listType: string, ids: string) => ({
    type: ACTIONS.FOLLOW_SOCCEERS,
    payload: {
        listType,
        ids,
    },
});

export const followSoccer = (listType: string, ids: string) => ({
    type: ACTIONS.FOLLOW_SOCCEER,
    payload: {
        listType,
        ids,
    },
});

export const unfollowSoccer = (listType: string, listId: number, index: number) => ({
    type: ACTIONS.UNFOLLOW_SOCCEER,
    payload: {
        listType,
        listId,
        index
    },
});
